<template>
  <div>
    <el-scrollbar
      ref="scrollContainer"
      :vertical="false"
      :class="['scroll-container', isShow ? 'scrollClass' : '']"
      @wheel.native.prevent="handleScroll"
    >
      <span
        v-if="isShow"
        :class="['el-tabs__nav-prev', noLeft ? 'disabled' : '']"
        ><i class="el-icon-arrow-left" @click="leftFn"></i
      ></span>
      <slot />
      <span
        v-if="isShow"
        :class="['el-tabs__nav-next', noRight ? 'disabled' : '']"
        ><i class="el-icon-arrow-right" @click="rightFn"></i
      ></span>
    </el-scrollbar>
  </div>
</template>

<script>
const tagAndTagSpacing = 4 // tagAndTagSpacing

export default {
  name: 'ScrollPane',
  data() {
    return {
      left: 0,
      isShow: false,
      noLeft: false,
      noRight: false,
    }
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    },
  },
  mounted() {
    let _that = this
    window.onresize = function () {
      _that.scrollFn()
    }
    this.scrollWrapper.addEventListener('scroll', this.emitScroll, true)
  },
  beforeDestroy() {
    this.scrollWrapper.removeEventListener('scroll', this.emitScroll)
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      if ($scrollWrapper.scrollLeft < 20) {
        this.noLeft = true
        this.noRight = false
      }
      if (
        $scrollWrapper.scrollLeft >
        $scrollWrapper.scrollWidth - $containerWidth + 50
      ) {
        this.noLeft = false
        this.noRight = true
      }
    },
    emitScroll() {
      this.$emit('scroll')
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      const tagList = this.$parent.$refs.tag
      this.scrollFn()
      let firstTag = null
      let lastTag = null

      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0]
        lastTag = tagList[tagList.length - 1]
      }

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft =
          $scrollWrapper.scrollWidth - $containerWidth + 72
      } else {
        // find preTag and nextTag
        const currentIndex = tagList.findIndex(item => item === currentTag)
        const prevTag = tagList[currentIndex - 1]
        const nextTag = tagList[currentIndex + 1]

        // the tag's offsetLeft after of nextTag
        const afterNextTagOffsetLeft =
          nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing

        // the tag's offsetLeft before of prevTag
        const beforePrevTagOffsetLeft =
          prevTag.$el.offsetLeft - tagAndTagSpacing

        if (
          afterNextTagOffsetLeft >
          $scrollWrapper.scrollLeft + $containerWidth
        ) {
          $scrollWrapper.scrollLeft =
            afterNextTagOffsetLeft - $containerWidth + 72
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
        }
      }
    },
    scrollFn() {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      if ($scrollWrapper.scrollWidth - $containerWidth > 0) {
        this.isShow = true
        if (this.$refs.scrollContainer.$refs.wrap.scrollLeft < 20) {
          this.noLeft = true
          this.noRight = false
        }
        if (
          this.$refs.scrollContainer.$refs.wrap.scrollLeft >
          $scrollWrapper.scrollWidth - $containerWidth + 50
        ) {
          this.noLeft = false
          this.noRight = true
        }
      } else {
        this.isShow = false
      }
    },
    leftFn() {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = 0
      this.noLeft = true
      this.noRight = false
    },
    rightFn() {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft =
        $scrollWrapper.scrollWidth - $containerWidth + 72
      this.noLeft = false
      this.noRight = true
    },
  },
}
</script>

<style lang="scss" scoped>
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 100%;
  ::v-deep {
    .el-scrollbar__bar {
      bottom: 0px;
    }
    .el-scrollbar__wrap {
      height: 49px;
    }
  }
}
.el-tabs__nav-next,
.el-tabs__nav-prev {
  position: absolute;
  cursor: pointer;
  font-size: 12px;
  color: #000;
  z-index: 1;
  background-color: #fff;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  height: 33px;
}
.el-tabs__nav-prev {
  left: 0;
}
.el-tabs__nav-next {
  right: 0;
}
[class*=' el-icon-'],
[class^='el-icon-'] {
  font-family: element-icons !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
.el-icon-arrow-left:before {
  content: '';
  font-size: 16px;
  font-weight: bold;
}
.el-icon-arrow-right:before {
  content: '';
  font-size: 16px;
  font-weight: bold;
}
.scrollClass {
  width: auto;
  padding: 0 32px;
}
.disabled {
  color: #aaa;
}
</style>
